import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { apiUrl } from "../constants/urls";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache",
      'Access-Control-Allow-Headers': 'X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method',
      'Access-Control-Allow-Credentials': 'true',
      'Allow': 'GET, POST, OPTIONS, PUT, DELETE',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
      'Access-Control-Allow-Origin': '*',
    }),
  };

  public isLoggedIn(): boolean {
    if (localStorage.getItem("currentUser")) {
      return true;
    }
    return false;
  }

  login(username: string, password: string) {
    var body = `username=${username}&password=${password}&scope=bo`;
    return this.http.post<any>(`${apiUrl}/Token`, body, this.httpOptions).pipe(
      map((user) => {
        if (user && user.accessToken) {
          user.activeSession = true;
          localStorage.setItem("currentUser", JSON.stringify(user));
        } else {
          user.activeSession = false;
        }

        return user;
      })
    );
  }

  logout() {
    localStorage.removeItem("currentUser");
  }
}
